exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sortPagesPanel_ywQTE57GLluZtGaaLxtf9 {\n  box-sizing: border-box;\n}\n\n.IA_sortingPage_1N1jY4q-m4HJyVm9mMsFd1 {\n  float: left;\n  width: calc(100% - 80px);\n  height: 50px;\n  box-shadow: rgba(0, 0, 0, 0.2) 0 0 5px 0;\n  margin-top: 20px;\n  background: #ffffff;\n  margin-left: 40px;\n}\n\n.IA_sortingPageText_2HgoK_SNGiiRWQyPdrkv6S {\n  float: left;\n  line-height: 50px;\n  margin-left: 14px;\n  font-size: 16px;\n  color: #333333;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_sortPagesPanel": "IA_sortPagesPanel_ywQTE57GLluZtGaaLxtf9",
	"IA_sortingPage": "IA_sortingPage_1N1jY4q-m4HJyVm9mMsFd1",
	"IA_sortingPageText": "IA_sortingPageText_2HgoK_SNGiiRWQyPdrkv6S"
};